import { Component, HostListener, Input, OnInit } from '@angular/core';
import { CardList } from '@shared/models/card-list';
import { Config } from '@core/config';
import { FiltersComponent } from '@shared/components/filters/filters.component';
import {
  getActualImage,
  getCategoryName,
  onImageError,
} from '@app/@shared/tools/tools';
import { GAService } from '@app/@shared/services/google-analytics.service';
import { CardService } from '@app/cards/card.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-nearby-poi',
  templateUrl: './nearby-poi.component.html',
  styleUrls: ['./nearby-poi.component.scss'],
})
export class NearbyPoiComponent implements OnInit {
  @Input() cards: CardList[];
  public isMobile: boolean;
  public currentScreenWidth: number;
  public rowNumber: number;
  public icons = Config.iconSubCat;

  constructor(
    public gaService: GAService,
    private cardService: CardService,
    private location: Location
  ) {
    this.isMobile =
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
  }

  ngOnInit(): void {
    this.onResize();
  }

  /**
   * Set the current @this _currentScreenWidth attribute with actual screen width device.
   */
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.currentScreenWidth = this.isMobile
      ? window.screen.width
      : window.innerWidth;
    this.rowNumber =
      this.currentScreenWidth >= 1680 ||
      (this.currentScreenWidth < 1400 && this.currentScreenWidth >= 900)
        ? 4
        : 2;
  }

  get_icon(card: CardList): string {
    const circuit = FiltersComponent._translateCircuitType(card.circuitType, 1)
      ? 1
      : FiltersComponent._translateCircuitType(card.circuitType, 2)
      ? 2
      : FiltersComponent._translateCircuitType(card.circuitType, 4)
      ? 4
      : FiltersComponent._translateCircuitType(card.circuitType, 8)
      ? 8
      : FiltersComponent._translateCircuitType(card.circuitType, 16)
      ? 16
      : 32;
    return 'circuit_' + circuit;
  }

  refreshPage(): void {
    setTimeout(function () {
      location.reload();
    }, 1000);
  }

  /**
   * Get the correct image given the param.
   * When no data is founded, then we it's a placeholder that is returned.
   * @param {CardList} mc
   * @returns {string} url string.
   */
  getCurrentImage(mc: CardList): string {
    return getActualImage(parseInt(mc.category), mc.image?.url);
  }

  /**
   * We use this to manage error callback from image call.
   * @param {CardList} mc
   */
  manageImageError(mc: CardList, img: HTMLImageElement): void {
    onImageError(parseInt(mc.category), img);
  }

  /**
   * GA event for neaby poi.
   * @param {CardModel} card The current card model clicked. Should be that but no so heu yes no question.
   */
  public async sendUpGaEvent(card: any) {
    const detailedCard = await this.cardService.getCard(card.id).toPromise();
    this.gaService.sendEvent(
      getCategoryName(card),
      'Proximité',
      `Fiche ${detailedCard.innerID ?? detailedCard.old_id}`
    );
  }
}
